<div class="modal-body">
    <div class="content">
        <div class="input-block">
            <div class="panel-label">Наименование<span class="required"><sup>*</sup></span></div>
            <input type="text" class="panel-input" [formControl]="nameControl"/>
        </div>
        <div class="button">
            <app-button [buttonClass]="'big-purple-gradient'" [text]="'Сохранить'" (buttonClick)="saveSearch()"></app-button>
        </div>
    </div>
</div>
